export const WA_NUMBER = "6287782600300";
